export type Amount = {
  value: number;
  centValue: number;
  currency: string;
};

export function formatPrice(
  value: number,
  currency = 'EUR',
  options?: { rounded?: boolean },
): string {
  const price = value > 0 ? value : 0;
  const fractionDigits = options?.rounded ? 0 : 2;

  return price.toLocaleString(undefined, {
    style: 'currency',
    currency,
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  });
}

export function formatAmount(
  amount: Amount,
  options?: { rounded?: boolean },
): string {
  return formatPrice(amount.value, amount.currency, options);
}
